export default __webpack_public_path__ + "static/media/blog-img157.04a0745e.jpg";